// Icon components for segment boxes
const YesIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_14049_111083)">
      <path
        d="M6.00016 8.00065L7.3335 9.33398L10.0002 6.66732M14.6668 8.00065C14.6668 11.6826 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6826 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z"
        stroke="#50AC5A"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_14049_111083">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const PartialIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_14049_111088)">
      <path
        d="M8.00016 1.33398C9.29359 1.33375 10.5592 1.70977 11.6426 2.41622C12.7261 3.12267 13.5806 4.12904 14.1021 5.31268C14.6236 6.49631 14.7896 7.80609 14.5797 9.08237C14.3698 10.3587 13.7932 11.5463 12.9202 12.5007M1.66683 5.91732C1.4544 6.56309 1.34198 7.23756 1.3335 7.91732M1.88688 10.6673C2.26122 11.5285 2.81327 12.301 3.50688 12.934M3.09082 3.4906C3.27685 3.28809 3.47523 3.09728 3.68482 2.91927M5.76286 14.2807C7.42532 14.8729 9.25479 14.7818 10.8502 14.0273"
        stroke="#E8A60A"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 7.99935L7.33333 9.33268L10 6.66602"
        stroke="#E8A60A"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_14049_111088">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const NoIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_14049_111094)">
      <path
        d="M10.0002 6.00065L6.00016 10.0007M6.00016 6.00065L10.0002 10.0007M14.6668 8.00065C14.6668 11.6826 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6826 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z"
        stroke="#C02A14"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_14049_111094">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const SearchingIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.3335 14.6673H12.6668M3.3335 1.33398H12.6668M11.3335 14.6673V11.886C11.3334 11.5324 11.1929 11.1933 10.9428 10.9433L8.00016 8.00065M8.00016 8.00065L5.0575 10.9433C4.80743 11.1933 4.6669 11.5324 4.66683 11.886V14.6673M8.00016 8.00065L5.0575 5.05798C4.80743 4.80799 4.6669 4.46891 4.66683 4.11532V1.33398M8.00016 8.00065L10.9428 5.05798C11.1929 4.80799 11.3334 4.46891 11.3335 4.11532V1.33398"
      stroke="#60A5FA"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const NotFoundIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_14049_111105)">
      <path
        d="M8.00016 5.33398V8.00065M8.00016 10.6673H8.00683M14.6668 8.00065C14.6668 11.6826 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6826 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z"
        stroke="#71717A"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_14049_111105">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ConflictsIcon = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_14049_111110)">
      <path
        d="M12.0602 6.91406C12.6904 7.14901 13.2512 7.53908 13.6907 8.0482C14.1302 8.55731 14.4343 9.16902 14.5747 9.82678C14.7152 10.4845 14.6875 11.1671 14.4943 11.8113C14.301 12.4555 13.9485 13.0406 13.4692 13.5125C12.9899 13.9843 12.3994 14.3277 11.7522 14.5109C11.1051 14.694 10.4222 14.7111 9.76668 14.5604C9.1112 14.4097 8.5043 14.0961 8.00211 13.6487C7.49991 13.2013 7.11864 12.6345 6.89355 12.0007M9.3335 5.33398C9.3335 7.54312 7.54264 9.33398 5.3335 9.33398C3.12436 9.33398 1.3335 7.54312 1.3335 5.33398C1.3335 3.12485 3.12436 1.33398 5.3335 1.33398C7.54264 1.33398 9.3335 3.12485 9.3335 5.33398Z"
        stroke={color || "#EA580C"}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.77783 10.1113L11.5556 11.8891M11.5556 10.1113L9.77783 11.8891"
        stroke={color || "#EA580C"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 5.3342L4.88889 6.22309L6.66667 4.44531"
        stroke={color || "#EA580C"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_14049_111110">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export {
  YesIcon,
  PartialIcon,
  NoIcon,
  SearchingIcon,
  NotFoundIcon,
  ConflictsIcon,
};
